import {
  CreateSourceBrowserbaseAction,
  CreateSourceBrowserbaseActionType,
  SetApiKeyAction,
  SetErrorAction,
  SetManagementModeAction,
  SetMaxUrlsToScrapeAction,
  SetPhaseAction,
  SetProjectIdAction,
  SetPromptAction,
  SetShouldShowErrorsAction,
  SetSourceNameAction,
  SetUrlAction,
} from "@/pages/sources/components/create/sources/browserbase/actions";
import {
  CreateSourceBrowserbasePhase,
  CreateSourceBrowserbaseState,
} from "@/pages/sources/components/create/sources/browserbase/types";

function setSourceName(
  state: CreateSourceBrowserbaseState,
  action: SetSourceNameAction,
): CreateSourceBrowserbaseState {
  return {
    ...state,
    sourceName: action.payload,
  };
}

function setUrl(
  state: CreateSourceBrowserbaseState,
  action: SetUrlAction,
): CreateSourceBrowserbaseState {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      rootUrl: action.payload,
    },
  };
}

function setPrompt(
  state: CreateSourceBrowserbaseState,
  action: SetPromptAction,
): CreateSourceBrowserbaseState {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      prompt: action.payload,
    },
  };
}

function setManagementMode(
  state: CreateSourceBrowserbaseState,
  action: SetManagementModeAction,
): CreateSourceBrowserbaseState {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      isGalaxyManagedCredentials: action.payload,
    },
  };
}

function setApiKey(
  state: CreateSourceBrowserbaseState,
  action: SetApiKeyAction,
): CreateSourceBrowserbaseState {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      apiKey: action.payload,
    },
  };
}

function setProjectId(
  state: CreateSourceBrowserbaseState,
  action: SetProjectIdAction,
): CreateSourceBrowserbaseState {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      projectId: action.payload,
    },
  };
}

function setMaxUrlsToScrape(
  state: CreateSourceBrowserbaseState,
  action: SetMaxUrlsToScrapeAction,
): CreateSourceBrowserbaseState {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      scrapeLimit: action.payload,
    },
  };
}

function setPhase(
  state: CreateSourceBrowserbaseState,
  action: SetPhaseAction,
): CreateSourceBrowserbaseState {
  return {
    ...state,
    phase: action.payload,
    error: action.payload === CreateSourceBrowserbasePhase.ERROR ? state.error : null,
  };
}

function setError(
  state: CreateSourceBrowserbaseState,
  action: SetErrorAction,
): CreateSourceBrowserbaseState {
  return {
    ...state,
    error: action.payload,
    phase: action.payload ? CreateSourceBrowserbasePhase.ERROR : state.phase,
  };
}

function setShouldShowErrors(
  state: CreateSourceBrowserbaseState,
  action: SetShouldShowErrorsAction,
): CreateSourceBrowserbaseState {
  return {
    ...state,
    shouldShowErrors: action.payload,
  };
}

const createSourceBrowserbaseReducer = (
  state: CreateSourceBrowserbaseState,
  action: CreateSourceBrowserbaseAction,
): CreateSourceBrowserbaseState => {
  switch (action.type) {
    case CreateSourceBrowserbaseActionType.SET_SOURCE_NAME:
      return setSourceName(state, action);
    case CreateSourceBrowserbaseActionType.SET_URL:
      return setUrl(state, action);
    case CreateSourceBrowserbaseActionType.SET_PROMPT:
      return setPrompt(state, action);
    case CreateSourceBrowserbaseActionType.SET_MANAGEMENT_MODE:
      return setManagementMode(state, action);
    case CreateSourceBrowserbaseActionType.SET_API_KEY:
      return setApiKey(state, action);
    case CreateSourceBrowserbaseActionType.SET_PROJECT_ID:
      return setProjectId(state, action);
    case CreateSourceBrowserbaseActionType.SET_MAX_URLS_TO_SCRAPE:
      return setMaxUrlsToScrape(state, action);
    case CreateSourceBrowserbaseActionType.SET_PHASE:
      return setPhase(state, action);
    case CreateSourceBrowserbaseActionType.SET_ERROR:
      return setError(state, action);
    case CreateSourceBrowserbaseActionType.SET_SHOULD_SHOW_ERRORS:
      return setShouldShowErrors(state, action);
  }
};

export default createSourceBrowserbaseReducer;
